// Menu Consultas (2026-10-04) — antecedentes criminais e CPF pela API
// Full. Backend src/consultations (token por empresa, histórico gravado).
import { gpsDriveGet, gpsDrivePost } from "@/lib/api/gpsdrive-client";

export type ConsultationType = "completa" | "antecedentes" | "cpf_simples" | "cpf_completo";

export interface ConsultationAccess {
  view: boolean;
  configure: boolean;
  scope: "company" | "own";
}

export interface ConsultationSettings {
  hasToken: boolean;
  balance: unknown;
  balanceError: string | null;
}

export interface Consultation {
  id: string;
  type: ConsultationType;
  document: string;
  purpose: string | null;
  status: "sucesso" | "erro";
  message: string | null;
  userName: string | null;
  pdfUrl: string | null;
  createdAt: string;
  result?: unknown;
}

const BASE = "/api/v1/consultations";

export const consultationsService = {
  access: () => gpsDriveGet<ConsultationAccess>(`${BASE}/access`),
  settings: () => gpsDriveGet<ConsultationSettings>(`${BASE}/settings`),
  run: (body: { type: ConsultationType; cpf: string; pdf?: boolean; purpose: string }) => gpsDrivePost<Consultation>(BASE, body),
  list: (params: { limit: number; offset: number; document?: string }) => {
    const q = new URLSearchParams({ limit: String(params.limit), offset: String(params.offset) });
    if (params.document) q.set("document", params.document);
    return gpsDriveGet<{ items: Consultation[]; total: number }>(`${BASE}?${q}`);
  },
  get: (id: string) => gpsDriveGet<Consultation>(`${BASE}/${id}`),
};

// Crédito pago (2026-10-06): R$ 5,00 por consulta via PIX. Cliente paga
// pra conta Asaas da empresa; desde 2026-10-09 admin/funcionário também
// pagam — pra conta Asaas da plataforma (payee "platform"), e na 1ª compra
// informam o CPF/CNPJ da empresa (needsBillingDocument).
export interface ConsultationCredits {
  required: boolean;
  price: number;
  balance: number;
  pendingPurchase: { entryId: string; createdAt: string } | null;
  payee?: "company" | "platform";
  needsBillingDocument?: boolean;
}

export interface ConsultationCreditPix {
  entryId: string;
  paymentId: string;
  value: number;
  encodedImage: string;
  payload: string;
  expirationDate: string | null;
}

export const consultationCreditsService = {
  status: () => gpsDriveGet<ConsultationCredits>(`${BASE}/credits`),
  purchase: (amount: number, cpfCnpj?: string) =>
    gpsDrivePost<ConsultationCreditPix>(`${BASE}/credits/purchase`, { amount, ...(cpfCnpj ? { cpfCnpj } : {}) }),
};
